function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function findTrackedBrandInText(text: string, brands: { name: string }[]): string | null {
  for (const brand of brands) {
    const name = brand.name.trim();
    if (!name) continue;
    const pattern = new RegExp(`(^|[^\\p{L}\\p{N}])${escapeRegExp(name)}([^\\p{L}\\p{N}]|$)`, "iu");
    if (pattern.test(text)) return name;
  }
  return null;
}

export function findTrackedBrandsInText(text: string, brands: { name: string }[]): string[] {
  return brands
    .map((brand) => brand.name.trim())
    .filter((name) => name.length > 0)
    .filter((name) => {
      const pattern = new RegExp(`(^|[^\\p{L}\\p{N}])${escapeRegExp(name)}([^\\p{L}\\p{N}]|$)`, "iu");
      return pattern.test(text);
    });
}
